module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e8b661a1248933bed37b8800c4707f12.png";